import moment from 'moment'

const logger = {
  log: (message, payload) => {
    const logMessage = `${moment().toISOString()} - ${message}`
    if (payload) {
      console.log(logMessage, { ...payload })
    } else {
      console.log(logMessage)
    }
  }
}

export default logger
